import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/w3.css'

const app = createApp(App);

app.config.globalProperties.$filters = {
}

//app.config.globalProperties.$apiUrl = 'http://localhost:9092';
app.config.globalProperties.$apiUrl = '';
//app.config.globalProperties.$apiUrl = 'https://agent.joyboycloud.com';
app.config.globalProperties.$userName = '';
app.config.globalProperties.$userPass = '';

// 全局过滤器
app.config.globalProperties.$filters = {
    formatNumber(value) {
      return new Intl.NumberFormat('zh-CN', {
        style: 'decimal', // 'decimal' or 'currency'、'percent'
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      }).format(value);
    },
    formatDate(value,format = 'YYYY/MM/DD HH:mm:ss') {

        if (!value) return ''
        
        const date = new Date(value)
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day = String(date.getDate()).padStart(2, '0')
        const hours = String(date.getHours()).padStart(2, '0')
        const minutes = String(date.getMinutes()).padStart(2, '0')
        const seconds = String(date.getSeconds()).padStart(2, '0')
        
        return format
          .replace('YYYY', year)
          .replace('MM', month)
          .replace('DD', day)
          .replace('HH', hours)
          .replace('mm', minutes)
          .replace('ss', seconds)
      
    }
}



app.use(router);

app.mount('#app');
